import { KulionerRepositoryInterface } from "@/data/persistences/repositories/contracts/KulionerRepositoryInterface";
import { KulionerListRequest, KulionerConfirmOrderRequest } from "@/data/payload/api/KulionerApiRequest";
import ApiService from "../../services/ApiService";
import { KulionerMapper } from "@/data/persistences/mappers/KulionerMapper";
import { KulionerEndpoint } from "../../endpoints/KulionerEndpoint";
import { DownloadReportRequest } from "@/domain/entities/Kulioner";

export class KulionerApiRepository implements KulionerRepositoryInterface {
  private readonly service: ApiService;
  private readonly mapper: KulionerMapper;
  private readonly endpoints: KulionerEndpoint;

  constructor(
    service: ApiService,
    mapper: KulionerMapper,
    endpoints: KulionerEndpoint
  ) {
    this.service = service;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  async getList(params: KulionerListRequest) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getKulionerList(params)
    );

    return this.mapper.convertKulionerListFromApi(res);
  }

  async get(id: number) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getKulionerDetail(id)
    );

    return this.mapper.convertKulionerDetailFromApi(res);
  }
  async updateToggle(id: number) {
    const res = await this.service.invoke(
      "POST",
      this.endpoints.updateToggle(id)
    );

    return true
  }
  async updateKulioner(payload: KulionerConfirmOrderRequest): Promise<boolean> {
    const res = await this.service.invoke(
      "POST",
      this.endpoints.updateKulioner(),
      {},
      payload as KulionerConfirmOrderRequest
    );

    return true;
  } 
  
  async getDownloadReports(params: DownloadReportRequest): Promise<boolean> {
    await this.service.invoke("GET", this.endpoints.getDownloadReports(params));
  
    return true;
  }

  async getListSummaryStatus(params: KulionerListRequest) {
    const res = await this.service.invoke(
      "GET",
      this.endpoints.getListSummaryStatus(params)
    );

    return this.mapper.convertKulionerListSummaryFromApi(res);
  }
}
